import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useSelector } from "react-redux";

const Features = () => {
    const { id } = useParams();

    const permissions = useSelector((state) => state.status.permissions);

    const { data: features, refetch: refetchFeatures } = useGetPageQuery("features?per_page=100&category_id=" + id);
    const [deleteFeatur, { isLoading, isError }] = useSendFormMutation();
    const { data: categorySelect } = useGetPageQuery("categories/select");

    const [featuresList, setFeaturesList] = useState([]);

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setFeaturesList([...featuresList, e.target.value]);
        } else if (!e.target.checked) {
            setFeaturesList([...featuresList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteFeaturesHandler = async () => {
        for (const feater of featuresList) {
            await deleteFeatur({ body: {}, url: "features/" + feater, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchFeatures();
    };

    const checkAllHandler = () => {
        setFeaturesList(features.data.map((user) => user.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            await refetchFeatures();
        };
        refetch();
    }, [features]);

    return (
        <>
            {features && categorySelect && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3 flex-wrap">
                            <div className="header">
                                <h1>Характеристики</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link to={"/feature"} className="add btn btn-primary">
                                        Додати характеристику
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <a className="check_all" onClick={checkAllHandler}>
                            Виділити все
                        </a>
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-9">
                                <table className="table table-striped ui-sortable">
                                    <thead>
                                        <tr>
                                            <th data-field="move"></th>
                                            <th data-field="check"></th>
                                            <th data-field="id" className="no-mobile">
                                                ID
                                            </th>
                                            <th data-field="user_name">Назва</th>
                                            <th data-field="user_name" className="no-mobile">
                                                Назва в магазині
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {features.data.map((feature) => {
                                            return (
                                                <tr className="crow" key={feature.id}>
                                                    <td className="td_move fit">
                                                        <input type="hidden" name="positions[149]" value="149" />
                                                        <i className="bi bi-list"></i>
                                                    </td>
                                                    <td className="check_area text-right">
                                                        <div className="custom-control form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={featuresList.includes(feature.id.toString())}
                                                                onChange={(e) => listCheckHandler(e)}
                                                                value={feature.id}
                                                            />
                                                            <label className="custom-control-label" for="check_u149">
                                                                &nbsp;
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td className="no-mobile" style={{ width: "50px" }}>
                                                        #{feature.id}
                                                    </td>
                                                    <td>
                                                        <Link to={"/feature/" + feature.id}>{feature.title}</Link>
                                                    </td>
                                                    <td className="no-mobile">{feature.title_website}</td>
                                                    <td style={{ width: "40px" }}>
                                                        <i className="bi bi-funnel-fill"></i>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                {permissions.includes("feature_edit") || permissions.includes("all") ? (
                                    <div className="d-flex">
                                        <select name="action" className="form-select" style={{ width: "auto" }}>
                                            <option value="delete">Видалити</option>{" "}
                                        </select>
                                        <button className="btn btn-info mx-3" onClick={deleteFeaturesHandler}>
                                            {isLoading ? "Завантаження" : "Виконати"}
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-12 col-sm-6 col-md-3">
                                <div className="list-group mx-1 my-1">
                                    <Link
                                        className={id === "0" ? "list-group-item active" : "list-group-item"}
                                        to={"/features/0"}
                                    >
                                        Всі категорії
                                    </Link>
                                    {categorySelect.map((category) => {
                                        return (
                                            <Link
                                                className={
                                                    id === category.id.toString()
                                                        ? "list-group-item active"
                                                        : "list-group-item"
                                                }
                                                to={"/features/" + category.id}
                                            >
                                                {category.title}
                                            </Link>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Features;
